import VideoEventiCorrelatiContainer from './VideoEventiCorrelatiContainer';

export default VideoEventiCorrelatiContainer;
